document.addEventListener('DOMContentLoaded', function () {
  
    /***__ Hero Slider __****/
    document.querySelectorAll(".custSs").forEach(slideshow => {
        const slides = Array.from(slideshow.querySelectorAll(".custSs__slide"));
        const prev = slideshow.querySelector(".custSs__arrow--prev");
        const next = slideshow.querySelector(".custSs__arrow--next");
        const dots = Array.from(slideshow.querySelectorAll(".custSs__dot"));

        let index = 0;
        const autoplay = slideshow.dataset.autoplay === "true";
        const speed = parseInt(slideshow.dataset.speed);

        function showSlide(i) {
            slides.forEach(slide => slide.classList.remove("is-active"));
            if (dots.length > 0) {
                dots.forEach(dot => dot.classList.remove("is-active"));
            }

            index = (i + slides.length) % slides.length;

            slides[index].classList.add("is-active");
            if (dots.length > 0) {
                dots[index].classList.add("is-active");
            }
        }

        if (autoplay) {
            setInterval(() => showSlide(index + 1), speed);
        }

        if (prev) prev.addEventListener("click", () => showSlide(index - 1));
        if (next) next.addEventListener("click", () => showSlide(index + 1));

        dots.forEach((dot, i) => {
            dot.addEventListener("click", () => showSlide(i));
        });
    });

    /***__ Testimonial Carousal __****/  

    document.querySelectorAll(".testiCar").forEach(carousel => {

    const track = carousel.querySelector(".testiCar__track");
    const slides = carousel.querySelectorAll(".testiCar__slide");
    const dotsContainer = carousel.querySelector(".testiCar__dots");
    const prevBtn = carousel.querySelector(".testiCar__arrow--prev");
    const nextBtn = carousel.querySelector(".testiCar__arrow--next");
    const animationType = carousel.getAttribute("data-animation") || "slide";

    if (!track || slides.length === 0) return;

    let current = 0;
    const total = slides.length;

    /* -----------------------------
       Fade animation setup
    ----------------------------- */
    if (animationType === "fade") {
      slides.forEach((slide, i) => {
        slide.classList.add("fade");
        if (i === 0) slide.classList.add("is-active");
      });
    }

    /* -----------------------------
       DOTS
    ----------------------------- */
    let dots = [];
    if (dotsContainer) {
      slides.forEach((_, index) => {
        const dot = document.createElement("div");
        dot.className = "testiCar__dot";
        if (index === 0) dot.classList.add("is-selected");
        dot.addEventListener("click", () => goTo(index));
        dotsContainer.appendChild(dot);
      });
      dots = dotsContainer.querySelectorAll(".testiCar__dot");
    }

    /* --------------------------------------
      AUTO HEIGHT
    -------------------------------------- */
    function updateTrackHeight() {
        let activeSlide;

        if (animationType === "fade") {
        activeSlide = carousel.querySelector(".testiCar__slide.is-active");
        } else {
        activeSlide = slides[current];
        }

        if (!activeSlide) return;

        const newHeight = activeSlide.offsetHeight;
        track.style.height = newHeight + "px";
    }

    window.addEventListener("load", updateTrackHeight);
    setTimeout(updateTrackHeight, 50);

    function goTo(index) {
      if (animationType === "fade") {
        slides.forEach(slide => slide.classList.remove("is-active"));
        slides[index].classList.add("is-active");
      } else {
        track.style.transform = `translateX(-${index * 100}%)`;
      }
      current = index;
      if (dots && dots.length > 0) {
        dots.forEach(dot => dot.classList.remove("is-selected"));
        dots[current].classList.add("is-selected");
      }

        updateTrackHeight();
    }

    /* -----------------------------
       ARROWS
    ----------------------------- */
    prevBtn?.addEventListener("click", () => {
      const nextIndex = (current - 1 + total) % total;
      goTo(nextIndex);
    });

    nextBtn?.addEventListener("click", () => {
      const nextIndex = (current + 1) % total;
      goTo(nextIndex);
    });

    /* -----------------------------
       AUTOPLAY
    ----------------------------- */
    const autoplay = carousel.getAttribute("data-autoplay") === "true";
    const speed = Number(carousel.getAttribute("data-autoplay-speed")) * 1000;
    if (autoplay && speed > 0) {
      setInterval(() => {
        const nextIndex = (current + 1) % total;
        goTo(nextIndex);
      }, speed);
    }

    /* -----------------------------
       SWIPE SUPPORT
    ----------------------------- */
    let startX = 0;
    let endX = 0;

    track.addEventListener("touchstart", e => {
      startX = e.touches[0].clientX;
    });

    track.addEventListener("touchmove", e => {
      endX = e.touches[0].clientX;
    });

    track.addEventListener("touchend", () => {
      const diff = startX - endX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          // swipe left → next
          const nextIndex = (current + 1) % total;
          goTo(nextIndex);
        } else {
          // swipe right → prev
          const prevIndex = (current - 1 + total) % total;
          goTo(prevIndex);
        }
      }
    });

  });

});